import { FormMode, IBusinessListModel } from "src/types/models/apiModels";
import EntityList from "../../entity-list/entity-list";
import StatusBadge from "src/components/molecules/status-badge/status-badge";
import Label from "src/components/atoms/labels/label";
import { useEffect, useRef, useState } from "react";
import Banner from "src/components/molecules/banner/Banner";
import CreateReseller from "../reseller/create-reseller";
import { useAuth } from "../../auth/auth-context";
import { BusinessListViewModel } from "./business-list-view-model";
import LoadingPlaceHolder from "src/components/molecules/loading/loading-placeholder";
import { Dialog, DialogContent } from "@mui/material";
import BusinessViewer from "./business-view";
import LoadingModal from "src/components/molecules/loading/LoadingModal";
import Logo from "src/components/molecules/logo/Logo";

interface IBusinessListProps {
	onClose?: () => void;
	onSelect?: (business: IBusinessListModel) => void;
}

const BusinessForAdminList: React.FC<IBusinessListProps> = ({
	onClose,
	onSelect,
}) => {
	const { user } = useAuth();
	const [data, setData] = useState<IBusinessListModel[]>([]);
	const [filteredData, setFilteredData] = useState<IBusinessListModel[]>([]);
	const [mode, setMode] = useState<FormMode>(FormMode.List);
	const [loading, setLoading] = useState(true);
	const viewModel = useRef<BusinessListViewModel | null>(null);
	const [showSelectedBusiness, setShowSelectedBusiness] = useState(false);
	const [selectedBusiness, setSelectedBusiness] =
		useState<IBusinessListModel | null>(null);
	useEffect(() => {
		if (user && user.accessToken) {
			viewModel.current = new BusinessListViewModel(user.accessToken);
			fetchData();
		}
	}, []);

	const handleSelectBusiness = (business: IBusinessListModel) => {
		console.log(`handle selected business`, business);
	};

	const handleViewClicked = async (business: IBusinessListModel) => {
		setSelectedBusiness(business);
		setShowSelectedBusiness(true);
	};

	const renderBusinessItem = (business: IBusinessListModel) => (
		<>
			<div className="flex items-center justify-center gap-4 w-full">
				<div className="flex-shrink-0">
					{business.logo?.signedUrl ? (
						<>
							<Logo
								size={48}
								image={business.logo.signedUrl}
							></Logo>
						</>
					) : (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="size-12"
						>
							<path
								fillRule="evenodd"
								d="M2.25 5.25a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3V15a3 3 0 0 1-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.53-1.28l.621-.622a2.25 2.25 0 0 0 .659-1.59V18h-3a3 3 0 0 1-3-3V5.25Zm1.5 0v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5Z"
								clipRule="evenodd"
							/>
						</svg>
					)}
				</div>
				<div className="flex items-start justify-between w-full">
					<div className="flex items-center justify-center gap-2">
						<Label variant="subheader" text={business.name}></Label>
						{/* <span className="text-lg font-bold">
							{business.name}
						</span> */}
					</div>
					<div className="rounded-full">
						<StatusBadge status={business.status}></StatusBadge>
					</div>
				</div>
			</div>
		</>
	);

	const fetchData = async () => {
		setLoading(true);
		try {
			if (user && user.accessToken) {
				viewModel.current = new BusinessListViewModel(user.accessToken);
				setLoading(true);
				const response = await viewModel.current?.fetchList();
				setLoading(false);
				setData(response);
				setFilteredData(response); // Initialize filtered data
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<>
				<Banner label={"Businesses"}>
					<div className="bg-white p-6 rounded-lg drop-shadow-2xl w-full">
						{/* <div className="flex items-center justify-start gap-4">
							<CheckBox
								checked={true}
								title="New"
								onChange={function (value: boolean): void {
									throw new Error(
										"Function not implemented."
									);
								}}
							></CheckBox>
							<CheckBox
								checked={true}
								title="Approved"
								onChange={function (value: boolean): void {
									throw new Error(
										"Function not implemented."
									);
								}}
							></CheckBox>
							<CheckBox
								checked={true}
								title="Active"
								onChange={function (value: boolean): void {
									throw new Error(
										"Function not implemented."
									);
								}}
							></CheckBox>
						</div> */}
						<div className="flex flex-col items-center justify-center gap-12 w-full">
							{/* Add New Button */}
							{mode === FormMode.List && (
								<>
									{loading && (
										<LoadingPlaceHolder></LoadingPlaceHolder>
									)}
									<EntityList<IBusinessListModel>
										data={filteredData}
										selectMode={false} // or false depending on your requirements
										onItemSelected={(selectedBusiness) =>
											handleSelectBusiness(
												selectedBusiness
											)
										}
										renderChildren={renderBusinessItem}
										canAddNew={false}
										onAddNewClick={() =>
											console.log(`add new clicked`)
										}
										onViewClicked={(item) =>
											handleViewClicked(item)
										}
										listLabel={"Select Business"}
										onClose={onClose}
										filterText="Filter on business name"
										enableView={true}
										enableEdit={false}
										enableDelete={false}
									/>
								</>
							)}

							{/* Render Components Based on FormMode */}

							{mode === FormMode.New && (
								<CreateReseller></CreateReseller>
							)}

							{mode === FormMode.Edit && <CreateReseller />}
						</div>
					</div>

					<Dialog
						open={showSelectedBusiness}
						onClose={() => {
							setShowSelectedBusiness(false);
							fetchData();
						}}
						maxWidth="xl"
						fullWidth
						PaperProps={{
							style: {
								backgroundColor: "transparent",
								boxShadow: "none",
								width: "100%",
								alignContent: "centre",
								justifyContent: "center",
							},
						}}
					>
						<DialogContent
							style={{
								padding: 0,
								margin: 0,
								width: "100%", // Ensure it takes up the full width
								display: "flex",
								justifyContent: "center",
							}}
						>
							<Banner label={`${selectedBusiness?.name}`}>
								{selectedBusiness && (
									<BusinessViewer
										id={selectedBusiness?.businessId}
									></BusinessViewer>
								)}
							</Banner>
						</DialogContent>
					</Dialog>

					<LoadingModal open={loading}></LoadingModal>
				</Banner>
			</>
		</>
	);
};

export default BusinessForAdminList;
